__turbopack_context__.v({
  "card": "ioS3wq_card",
  "cardDetails": "ioS3wq_cardDetails",
  "cardNumber": "ioS3wq_cardNumber",
  "cardPlaceholder": "ioS3wq_cardPlaceholder",
  "content": "ioS3wq_content",
  "copyIcon": "ioS3wq_copyIcon",
  "logo": "ioS3wq_logo",
  "placeholderBadge": "ioS3wq_placeholderBadge",
  "placeholderWrapper": "ioS3wq_placeholderWrapper",
});
